import React from 'react';
import { BlockTypeButton } from './BlockTypeButton';

export function BlockquoteBlockButton({ store, theme, disabled }) {
	return (
		<BlockTypeButton store={store} theme={theme} disabled={disabled} blockType="blockquote">
			<i className="qa-ico-blockquote" title="引用">“</i>
		</BlockTypeButton>
	);
}


// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/plugins/blockStylePlugin/BlockquoteBlockButton.jsx